import React from "react";
import Container from "@/components/marketing/Container";
import SectionHeading from "@/components/marketing/SectionHeading";
import { Globe, Languages, ShieldCheck, Clock, BarChart3, Users } from "lucide-react";

const REASONS = [
  {
    icon: Globe,
    title: "Regional expertise",
    desc: "Our team has run campaigns across the UAE and Gulf for years. We know which outlets carry weight in this market.",
  },
  {
    icon: Languages,
    title: "Bilingual distribution",
    desc: "Your release goes out in Arabic and English, translated by native speakers, not machines. We handle both language markets fluently.",
  },
  {
    icon: ShieldCheck,
    title: "Guaranteed or refunded",
    desc: "Named pickups are confirmed in advance. If a guaranteed placement does not publish, you get a full refund under our refund policy.",
  },
  {
    icon: Clock,
    title: "Same-day submission",
    desc: "Submit today and your release goes out the same day. No long lead times or waiting for editorial calendars.",
  },
  {
    icon: BarChart3,
    title: "Full reporting",
    desc: "Every campaign comes with a full pickup report and live published links. You see exactly what was published and where.",
  },
  {
    icon: Users,
    title: "In-house PR team",
    desc: "A self-serve platform with real PR specialists behind it. Our team handles translation, pitching, and placement quality end to end, and journalist outreach campaigns are run personally by our strategists.",
  },
];

export default function UaeWhyUs() {
  return (
    <section className="py-12 lg:py-16 bg-slate/30">
      <Container>
        <SectionHeading
          tag="WHY DIGITAL24"
          title="Built for the UAE. Run by specialists."
          subtitle="We combine regional knowledge, bilingual capability, and a guaranteed delivery model so your story lands in the right outlets."
        />

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {REASONS.map((r) => (
            <div
              key={r.title}
              className="bg-white border border-border rounded-xl p-7 lg:p-9 flex flex-col hover:border-cobalt/30 transition-colors"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-cobalt/5 mb-5">
                <r.icon className="w-6 h-6 text-cobalt" strokeWidth={1.75} />
              </div>
              <h3 className="font-heading text-xl font-bold text-bone mb-2">{r.title}</h3>
              <p className="text-sm text-steel leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}